/* eslint-disable no-plusplus */
/* eslint-disable func-names */
/* eslint-disable indent */
import EDC from './globals';
/**
 *
 */
/* EDC.Preloaders.AnswersCounter = function(scene) {
    scene.load.image("answer-counter-correct", "../shared/assets/check-mark.png");
    scene.load.image("answer-counter-wrong", "../shared/assets/cross-mark.png");
}; */
/**
 *
 */
EDC.UI.AnswersCounter = function (scene) {
    this.scene = scene;

    this.width = 200;
    this.height = 100;

    this.bgContainer = null;

    this.correctSprite = null;
    this.correctSpriteRelX = 30;
    this.correctSpriteRelY = this.height / 2;

    this.wrongSprite = null;
    this.wrongSpriteRelX = this.width / 2 + 25;
    this.wrongSpriteRelY = this.height / 2;

    this.correctTexts = [];
    this.correctTextsContainer = null;
    this.correctMaskGraphics = null;
    this.correctTextsContainerRelX = 50;
    this.correctTextMaskRelX = 0;
    this.correctTextsContainerRelY = this.height / 2;

    this.wrongTexts = [];
    this.wrongTextsContainer = null;
    this.wrongMaskGraphics = null;
    this.wrongTextsContainerRelX = 150;
    this.wrongTextMaskRelX = 100;
    this.wrongTextsContainerRelY = this.height / 2;

    this.defaultX = 1710;
    this.defaultY = 970;

    this.textSize = 70;

    this.correctValue = 0;
    this.wrongValue = 0;

    this.slidingQueue = [];
    this.isSliding = false;

    return this;
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.create = function () {
    this.createBackground();
    this.createCorrect();
    this.createWrong();

    return this;
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.place = function (x, y) {
    this.bgContainer.setPosition(x, y);
    this.correctSprite.setPosition(this.bgContainer.x + this.correctSpriteRelX,
     this.bgContainer.y + this.correctSpriteRelY);
    this.wrongSprite.setPosition(this.bgContainer.x + this.wrongSpriteRelX,
     this.bgContainer.y + this.wrongSpriteRelY);
    this.correctTextsContainer.setPosition(this.bgContainer.x + this.correctTextsContainerRelX,
       this.bgContainer.y + this.correctTextsContainerRelY);
    this.updateTextMask(
        this.correctMaskGraphics,
        this.correctTextsContainer,
        this.bgContainer.x + this.correctTextsContainerRelX,
        this.bgContainer.y + this.correctTextsContainerRelY - this.textSize / 2,
        80,
        this.textSize,
    );
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.createBackground = function () {
    this.bgContainer = this.scene.add.container(this.defaultX, this.defaultY);
    const g = this.scene.add.graphics();
    g.fillStyle(0x000000, 0.5);
    g.fillRoundedRect(0, 0, this.width, this.height, 25);

    g.lineStyle(6, 0xffffff, 1);
    const strokesCount = 4;
    const spacesCount = strokesCount - 1;
    const strokeHeight = Math.round(this.height / (strokesCount + spacesCount));

    let currentStrokeY = 0;
    const currentStrokeX = Math.round(this.width / 2);
    g.beginPath();
    for (let i = 0; i < strokesCount; i++) {
        g.moveTo(currentStrokeX, currentStrokeY);
        g.lineTo(currentStrokeX, currentStrokeY + strokeHeight);
        currentStrokeY += strokeHeight * 2;
    }
    g.strokePath();

    this.bgContainer.add(g);
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.createCorrect = function () {
    this.correctTextsContainer = this.scene.add.container(
        this.bgContainer.x + this.correctTextsContainerRelX,
        this.bgContainer.y + this.correctTextsContainerRelY,
    );

    const points = [{ x: 0, y: 0 }, { x: 0, y: this.textSize }];

    for (let ti = 0; ti < points.length; ti++) {
        const text = this.scene.add.text(points[ti].x, points[ti].y, this.correctValue, {
            fontFamily: 'Arial',
            fontSize: `${this.textSize}px`,
            fontStyle: 'bold',
            color: '#00ff00',
        }).setOrigin(0.5, 0.5);
        this.correctTextsContainer.add(text);
        this.correctTexts.push(text);
    }

    this.correctMaskGraphics = this.scene.make.graphics();
    this.updateTextMask(
        this.correctMaskGraphics,
        this.correctTextsContainer,
        this.bgContainer.x + this.correctTextMaskRelX,
        this.bgContainer.y + this.correctTextsContainerRelY - this.textSize / 2,
        100,
        this.textSize,
    );
};
/**
 *
 */
// eslint-disable-next-line max-len
EDC.UI.AnswersCounter.prototype.updateTextMask = function (maskGraphics, targetContainer, x, y, width, height) {
    maskGraphics.clear();
    maskGraphics.fillStyle(0xff0000, 0.45);
    maskGraphics.fillRect(x, y, width, height);
    const mask = maskGraphics.createGeometryMask();
    targetContainer.setMask(mask);
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.createWrong = function () {
    this.wrongTextsContainer = this.scene.add.container(
        this.bgContainer.x + this.wrongTextsContainerRelX,
        this.bgContainer.y + this.wrongTextsContainerRelY,
    );

    const points = [{ x: 0, y: 0 }, { x: 0, y: this.textSize }];

    for (let ti = 0; ti < points.length; ti++) {
        const text = this.scene.add.text(points[ti].x, points[ti].y, this.wrongValue, {
            fontFamily: 'Arial',
            fontSize: `${this.textSize}px`,
            fontStyle: 'bold',
            color: '#ff0000',
        }).setOrigin(0.5, 0.5);
        this.wrongTextsContainer.add(text);
        this.wrongTexts.push(text);
    }

    this.wrongMaskGraphics = this.scene.make.graphics();
    this.updateTextMask(
        this.wrongMaskGraphics,
        this.wrongTextsContainer,
        this.bgContainer.x + this.wrongTextMaskRelX,
        this.bgContainer.y + this.wrongTextsContainerRelY - this.textSize / 2,
        100,
        this.textSize,
    );
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.incrementCounter = function () {
    const incrementData = this.slidingQueue.shift();
    if (incrementData) {
        this.isSliding = true;
        const targetTexts = incrementData.isCorrect ? this.correctTexts : this.wrongTexts;
        targetTexts[1].setText(incrementData.value);
        const lastY = targetTexts[1].y;
        for (let ti = 0; ti < targetTexts.length; ti++) {
            const text = targetTexts[ti];
            this.scene.tweens.add({
                targets: text,
                y: text.y - this.textSize,
                duration: 500,
                ease: 'Linear',
                onComplete: function (index, newY) {
                    if (index === 0) {
                        const firstElem = targetTexts.shift();
                        targetTexts.push(firstElem);
                        firstElem.y = newY;
                        this.isSliding = false;
                        this.incrementCounter();
                    }
                }.bind(this, ti, lastY),
            });
        }
    }
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.incrementCorrect = function () {
    this.correctValue++;
    if (this.correctValue > 99) {
        this.correctValue = 0;
    }
    const data = { isCorrect: true, value: this.correctValue };
    this.slidingQueue.push(data);

    if (!this.isSliding) this.incrementCounter();
};
/**
 *
 */
EDC.UI.AnswersCounter.prototype.incrementWrong = function () {
    this.wrongValue++;
    if (this.wrongValue > 99) {
        this.wrongValue = 0;
    }

    const data = { isCorrect: false, value: this.wrongValue };
    this.slidingQueue.push(data);

    if (!this.isSliding) this.incrementCounter();
};


/**
 *
 */
EDC.UI.AnswersCounter.prototype.testIncrementCorrect = function () {
    // setInterval(this.incrementCorrect.bind(this), 1200);
    for (let i = 0; i < 10; i++) {
        this.incrementCorrect();
    }
};

EDC.UI.AnswersCounter.prototype.testIncrementWrong = function () {
    // setInterval(this.incrementWrong.bind(this), 700);
    for (let i = 0; i < 15; i++) {
        this.incrementWrong();
    }
};

export default EDC.UI.AnswersCounter;
